<template>
  <div class="cards-grid-container">
    <v-card
      v-for="(card, i) in cards"
      :key="'rider-card-' + i"
      class="card-data"
      :class="{ 'card-data-active': selectedCardIndex === i }"
      :elevation="0"
      :ripple="false"
      style="cursor: pointer"
      @mousedown="$emit('select-card', i)"
    >
      <v-card-text>
        <div class="card-content">
          <div class="card-icon">
            <v-icon :color="card.color" size="40">
              {{ card.icon }}
            </v-icon>
          </div>

          <div class="d-flex flex-column">
            <span class="card-title">{{ card.title }}</span>

            <div class="d-flex align-end mt-1">
              <span class="card-value" :style="{ color: card.color }">
                {{ card.value }}
              </span>
              <span class="card-unit ml-1">ราย</span>
            </div>

            <span v-if="card.subText" class="card-sub-text">
              {{ card.subText }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "RiderCard",

  props: {
    ridersData: {
      type: Array,
      default: () => [],
    },
    selectedCardIndex: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    totalRiders() {
      return this.ridersData.length || 0;
    },

    pendingRiders() {
      return this.ridersData.filter((r) => this.normalizeStatus(r.status) === 'pending_approval').length;
    },

    activeRiders() {
      return this.ridersData.filter((r) => this.normalizeStatus(r.status) === 'active').length;
    },

    suspendedRiders() {
      return this.ridersData.filter((r) => this.normalizeStatus(r.status) === 'suspended').length;
    },

    rejectedRiders() {
      return this.ridersData.filter((r) => this.normalizeStatus(r.status) === 'rejected').length;
    },

    cards() {
      return [
        {
          key: "all_riders",
          title: "พนักงานส่งทั้งหมด",
          icon: "mdi-bike",
          color: "#F4811F",
          value: this.totalRiders,
          subText: this.totalRiders > 0 ? `รวมทั้งหมด ${this.totalRiders} ราย` : "",
        },
        {
          key: "pending_riders",
          title: "รอการอนุมัติ",
          icon: "mdi-clock-outline",
          color: "#F59E0B",
          value: this.pendingRiders,
          subText: this.pendingRiders > 0 ? `รอดำเนินการ ${this.pendingRiders} ราย` : "",
        },
        {
          key: "active_riders",
          title: "ใช้งานปกติ",
          icon: "mdi-check-circle-outline",
          color: "#198C19",
          value: this.activeRiders,
          subText: "",
        },
        {
          key: "suspended_riders",
          title: "ถูกระงับบัญชี",
          icon: "mdi-block-helper",
          color: "#EE2526",
          value: this.suspendedRiders,
          subText: "",
        },
      ];
    },
  },

  methods: {
    normalizeStatus(status) {
      const v = (status || "").toString().trim().toLowerCase();
      if (v === "pending_approval") return "pending_approval";
      if (v === "active") return "active";
      if (v === "inactive") return "inactive";
      if (v === "rejected") return "rejected";
      if (["suspended", "ban", "banned"].includes(v)) return "suspended";
      return "unknown";
    },
  },
};
</script>

<style scoped>
.cards-grid-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 1023px) {
  .cards-grid-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .cards-grid-container {
    grid-template-columns: 1fr;
  }
}
.card-data {
  border-radius: 16px;
  border: 1px solid #f3f5f7;
  background: #ffffff;
  min-height: 120px;
  display: flex;
  align-items: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
}
.card-data:hover {
  transform: scale(1.02);
  z-index: 10;
  background-color: #f9fafb;
  border-color: #d1d5db;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.04);
}
.card-data-active {
  background: #FEF3ED;
  border: 1px solid #F4811F;
  box-shadow: 0 6px 16px rgba(244, 129, 31, 0.25);
  transform: translateY(-2px);
}
.card-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.card-value {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}
.card-unit {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.card-sub-text {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
}
</style>
